import React from 'react';
import { Link } from 'react-router-dom';
import './Layout.scss';
import Menu from '../Menu/Menu';

const Layout = ({ children }) => {
  return (
    <div>
      <div className="layout-container">
        <div className="main-container">
          <header>
            <div className="header-logo">H</div>
            <div className="title-menu-wrapper">
              <div className="header-title">
                <h1>
                  <Link to="/">
                    Hacker News <span>by hafisalrafi</span>
                  </Link>
                </h1>
              </div>
              <Menu />
            </div>
          </header>
          <main>{children}</main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
